export const userManagementSharedT = {
  common: {
    actions: {
      close: 'Close'
    }
  },

  resetPassword: {
    actions: {
      buttonLabel: 'Reset password'
    },
    success: {
      title: 'Email sent',
      body1:
        'An email with a password reset link has been sent to the recipient.',
      body2: 'Please ask them to check their inbox and spam folder.',
      reachOut: 'If they don’t receive it soon, try again or contact support at'
    },
    error: {
      title: 'Unable to send reset email',
      body1: 'We couldn’t send the password reset email at the moment.',
      reachOut: 'Please try again shortly, or contact our support team at'
    }
  },

  roles: {
    labels: {
      admin: 'Admin',
      operationsMember: 'Operations member'
    },
    badges: {
      reviewer: 'Reviewer'
    }
  }
} as const;
